import { GraduationCap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white text-[var(--s800)] border-t border-[var(--s200)]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Unimora.in" className="w-14 h-14 rounded-[12px] object-cover shrink-0" />
            <div className="leading-none">
              <div className="text-[26px] font-bold tracking-tight text-[var(--s900)]">
                Unimora<span className="text-[var(--ind)]">.in</span>
              </div>
              <div className="mt-2 flex items-center gap-1.5 text-[12px] font-semibold tracking-[0.04em] text-[var(--s700)]">
                <GraduationCap size={14} strokeWidth={2.2} className="text-[var(--ind)]" />
                <span>Dream. Decide. Achieve.</span>
              </div>
            </div>
          </div>
          <p className="text-body-sm text-[var(--s600)] mt-5 max-w-md leading-relaxed">
            AI-powered university decision intelligence helping ambitious students and families to make confident global university decisions.
          </p>
        </div>
        <div>
          <div className="text-micro font-semibold tracking-[0.05em] uppercase text-[var(--s500)] mb-4">Platform</div>
          <ul className="space-y-2.5 text-body-sm text-[var(--s700)]">
            <li>University Atlas</li>
            <li>Side-by-side Compare</li>
            <li>Financial Plan</li>
            <li>The AI Counsel</li>
          </ul>
        </div>
        <div>
          <div className="text-micro font-semibold tracking-[0.05em] uppercase text-[var(--s500)] mb-4">Principles</div>
          <ul className="space-y-2.5 text-body-sm text-[var(--s700)]">
            <li>Decision First</li>
            <li>Data Before Opinion</li>
            <li>Coach, Don&apos;t Decide</li>
            <li>Trade-offs Always</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--s200)]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-5 flex flex-wrap items-center justify-between gap-3 text-label text-[var(--s500)] font-medium">
          <span>© 2026 Unimora.in · operated by Rameshwar Govindu, Hyderabad</span>
          {/* Plain links: these are static pages in public/, not React routes. */}
          <nav className="flex flex-wrap gap-4">
            <a href="/about" className="hover:text-[var(--ind)]">About</a>
            <a href="/contact" className="hover:text-[var(--ind)]">Contact</a>
            <a href="/privacy" className="hover:text-[var(--ind)]">Privacy</a>
            <a href="/terms" className="hover:text-[var(--ind)]">Terms</a>
            <a href="/refund" className="hover:text-[var(--ind)]">Refunds</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
